export default class Utils {
  /**
   * Returns a Date object with UTC time zone, with exact same Year, Month, Day, Hour, Minute and Second.
   * Note that this will not convert given Date object to UTC, but rather strip the timezone.
   *
   * @param date Local Date object.
   */

  static toUtcDate(date: Date): Date {
    return new Date(
      Date.UTC(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        date.getHours(),
        date.getMinutes(),
        date.getSeconds(),
      ),
    );
  }

  static toUtcDateISOString(value: string): string {
    if (value) {
      const date = new Date(value);
      return new Date(
        Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0),
      ).toISOString();
    }

    return undefined;
  }

  static getWeekNumber(date: Date): number {
    const datetime = new Date(date.getTime());
    datetime.setHours(0, 0, 0, 0);
    // Thursday in current week decides the year.
    datetime.setDate(datetime.getDate() + 3 - ((datetime.getDay() + 6) % 7));
    // January 4 is always in week 1.
    const week1 = new Date(datetime.getFullYear(), 0, 4);
    // Adjust to Thursday in week 1 and count number of weeks from date to week1.
    return (
      1 +
      Math.round(
        ((datetime.getTime() - week1.getTime()) / 86400000 - 3 + ((week1.getDay() + 6) % 7)) / 7,
      )
    );
  }

  static sortAscending<TArray, TProperty extends keyof TArray>(
    values: TArray[],
    sortProp: TProperty,
  ) {
    return values.sort((a, b) => {
      if (a[sortProp] < b[sortProp]) {
        return -1;
      }

      if (a[sortProp] > b[sortProp]) {
        return 1;
      }

      return 0;
    });
  }

  // eslint-disable-next-line
  static parseDateTimeFromFormValue(value: any) {
    if (value) {
      return typeof (<unknown>value) !== 'string'
        ? Utils.toUtcDate(<Date>value).toISOString()
        : <string>value;
    } else {
      return null;
    }
  }
}
